import React from 'react'
import { connect } from 'react-redux'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import CardActions from '@mui/material/CardActions'

function UserMenu({
  color = 'standard',
  authentication,
  userMenuAnchorEl,
  handleUserMenuOpen,
  handleUserMenuClose
}) {
  const isStandard = color === 'standard'

  const handleUserLogout = () => {
    handleUserMenuClose('/logout')
  }

  const renderUserMenuIconButton = (userMenuId) => {
    const { username } = authentication
    return (
      <IconButton
        aria-owns={userMenuAnchorEl ? userMenuId : null}
        aria-haspopup='true'
        id='logout-icon-button'
        onClick={handleUserMenuOpen}
        style={{ padding: 0, marginLeft: 12 }}>
        <Avatar
          sx={{
            backgroundColor: isStandard ? 'primary.main' : 'white',
            color: isStandard ? 'white' : 'primary.main',
            textTransform: 'uppercase'
          }}>
          {username[0]}
        </Avatar>
      </IconButton>
    )
  }

  const renderUserMenuItems = () => {
    return (
      <Button
        id='sair-button'
        fullWidth
        color='primary'
        variant='contained'
        onClick={handleUserLogout}>
        Sair
      </Button>
    )
  }

  const renderUserMenu = (userMenuId) => {
    const { username } = authentication
    return (
      <Menu
        id={userMenuId}
        anchorEl={userMenuAnchorEl}
        open={Boolean(userMenuAnchorEl)}
        onClose={handleUserMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { sx: { padding: 0, width: 150 } } }}
        MenuListProps={{ disablePadding: true }}>
        <Card elevation={0}>
          <CardContent>
            <Typography variant='subtitle2' color='textSecondary'>
              {username}
            </Typography>
          </CardContent>
          <CardActions>{renderUserMenuItems()}</CardActions>
        </Card>
      </Menu>
    )
  }

  const userMenuId = 'user-menu'
  return (
    authentication &&
    authentication.isUserAuthenticated && (
      <div>
        {renderUserMenuIconButton(userMenuId)}
        {renderUserMenu(userMenuId)}
      </div>
    )
  )
}

const mapStateToProps = ({ authentication }) => ({ authentication })
export default connect(mapStateToProps)(UserMenu)
